import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDipEvidenceCountDocument,
  type GetDipEvidenceCountQuery,
  type GetDipEvidenceCountQueryVariables,
} from "~/features/dataImportProjects/gqls";

/** Read-only DIP-scoped evidence total. */
export function useDipEvidenceCount(dataImportProjectId: string) {
  return useSuspenseQuery<GetDipEvidenceCountQuery, GetDipEvidenceCountQueryVariables>(GetDipEvidenceCountDocument, {
    variables: { dataImportProjectId },
  });
}
